import Image1 from './1-large.jpg'
import Image2 from './2-large.jpg'
import Image3 from './3-large.jpg'
import Image4 from './4-large.jpg'
import Image5 from './5-large.jpg'
import Image6 from './6-large.jpg'
import Image7 from './7-large.jpg'
import Image8 from './8-large.jpg'
import Image10 from './10-large.jpg'
import Image11 from './11-large.jpg'
import Image12 from './12-large.jpg'
import Image13 from './13-large.jpg'
import Image14 from './14-large.jpg'
import Image15 from './15-large.jpg'
import Image16 from './16-large.jpg'
import Image18 from './18-large.jpg'
import Image19 from './19-large.jpg'
import Image20 from './20-large.jpg'
import Image22 from './22-large.jpg'
import Image23 from './23-large.jpg'
import Image25 from './25-large.jpg'
import Image26 from './26-large.jpg'
import Image27 from './27-large.jpg'
import Image28 from './28-large.jpg'
import Image29 from './29-large.jpg'
import Image31 from './31-large.jpg'
import Image32 from './32-large.jpg'
import Image33 from './33-large.jpg'
import Image34 from './34-large.jpg'
import Image35 from './35-large.jpg'
import Image36 from './36-large.jpg'
import Image37 from './37-large.jpg'
import Image38 from './38-large.jpg'
import Image39 from './39-large.jpg'
import Image41 from './41-large.jpg'
import Image42 from './42-large.jpg'
import Image43 from './43-large.jpg'
import Image44 from './44-large.jpg'
import Image45 from './45-large.jpg'
import Image46 from './46-large.jpg'
import Image47 from './47-large.jpg'
import Image48 from './48-large.jpg'
import Image49 from './49-large.jpg'
import Image50 from './50-large.jpg'
import Image51 from './51-large.jpg'
import Image52 from './52-large.jpg'
import Image53 from './53-large.jpg'
import Image54 from './54-large.jpg'
import Image55 from './55-large.jpg'
import Image56 from './56-large.jpg'
import Image57 from './57-large.jpg'
import Image58 from './58-large.jpg'
import Image59 from './59-large.jpg'
import Image60 from './60-large.jpg'
import Image61 from './61-large.jpg'
import Image62 from './62-large.jpg'
import Image63 from './63-large.jpg'
import Image64 from './64-large.jpg'
import Image65 from './65-large.jpg'
import Image66 from './66-large.jpg'
import Image67 from './67-large.jpg'
import Image68 from './68-large.jpg'
import Image69 from './69-large.jpg'
import Image70 from './70-large.jpg'
import Image71 from './71-large.jpg'
import Image72 from './72-large.jpg'
import Image73 from './73-large.jpg'

export default [
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
  Image8,
  Image10,
  Image11,
  Image12,
  Image13,
  Image14,
  Image15,
  Image16,
  Image18,
  Image19,
  Image20,
  Image22,
  Image23,
  Image25,
  Image26,
  Image27,
  Image28,
  Image29,
  Image31,
  Image32,
  Image33,
  Image34,
  Image35,
  Image36,
  Image37,
  Image38,
  Image39,
  Image41,
  Image42,
  Image43,
  Image44,
  Image45,
  Image46,
  Image47,
  Image48,
  Image49,
  Image50,
  Image51,
  Image52,
  Image53,
  Image54,
  Image55,
  Image56,
  Image57,
  Image58,
  Image59,
  Image60,
  Image61,
  Image62,
  Image63,
  Image64,
  Image65,
  Image66,
  Image67,
  Image68,
  Image69,
  Image70,
  Image71,
  Image72,
  Image73,
]
